import { render, staticRenderFns } from "./PregledZaliha.vue?vue&type=template&id=9767bc7c&scoped=true&"
import script from "./PregledZaliha.vue?vue&type=script&lang=ts&"
export * from "./PregledZaliha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9767bc7c",
  null
  
)

export default component.exports